import { useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getVesselListQuery = (companyId) => {
    return axios.get(`${apiurl?.getVesselList}/${companyId}`);
};

const getVesselList = () => {
    return useMutation(['getVesselList'], getVesselListQuery);
};

export default getVesselList;
